module.exports = __webpack_public_path__ + "img/WIDE_HAI-LA-PARTITAIVA_1920x256.abe2a170.jpg";